import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { City } from 'src/app/classes/city';
import { Customer } from 'src/app/classes/customer';
import { SettingsService } from 'src/app/services/settings.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/services/auth.service';
import { CustomerService } from 'src/app/services/customer.service';
import CustomerTypes from 'src/app/constants/customer-types';
import { KeyValue } from '@angular/common';
import { AddressAutocompleteResult } from 'src/app/classes/address-autocomplete-result';

@Component({
  selector: 'app-shift-wizzard-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {

  validVatId = false
  loadingVat = false
  isLoggedIn = false
  customer: null | Customer = new Customer()
  customers: Customer[] = []
  fa = fa

  vat_id: string = ''
  name: string = ''
  office: string = ''
  type = 'individual'

  customerTypes = CustomerTypes

  constructor(public activeModal: NgbActiveModal,
    private authService: AuthService,
    private customerService: CustomerService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.authService.isSignedIn().subscribe(result => {
      this.isLoggedIn = result.signed_in

      if (this.isLoggedIn) {
        this.customerService.list().subscribe(customers => {
          this.customers = customers
        })
      }
    })
  }

  selectLocation() {

  }

  checkVatID() {
    if (!this.customer || !this.vat_id) {
      this.validVatId = false
      return
    }

    this.loadingVat = true

    this.customer.vat_id = this.vat_id

    this.customerService.vatStatus(this.customer as Customer).subscribe({
      next: (status) => {
        this.loadingVat = false
        this.validVatId = status.valid
      },
      error: (error) => {
        this.loadingVat = false
        this.validVatId = false
      }
    })
  }

  getAddress(result: AddressAutocompleteResult) {
    this.settingsService.areaByCoordinates(result.lat, result.long).subscribe({
      next: (area) => {
        
        this.customer = new Customer()

        // Area ID from the backend
        this.customer.area_id = area.id

        // Address components form the autocomplete component
        this.customer.street_address = result.street_address
        this.customer.city = result.city
        this.customer.postal_code = result.postal_code

        // Rest of data from the inputs
        this.customer.office = this.office
        this.customer.type = this.type
        this.customer.name = this.name
        this.customer.vat_id = this.vat_id

      },
      error: (error) => {
        this.customer = null
      }
    })
  }

  setCustomer(customer: Customer) {
    this.activeModal.close(customer)
  }

  setLocation() {
    if (this.customer && this.customer.area_id) {

      this.customer.office = this.office
      this.customer.type = this.type
      this.customer.name = this.name
      this.customer.vat_id = this.vat_id

      this.activeModal.close(this.customer)
    }

    else {
      this.activeModal.close()
    }
  }

  onCompare(_left: KeyValue<any, any>, _right: KeyValue<any, any>): number {
    return 0
  }
}
